export const mergeTypographyStyles = (baseStyles, overrides) => {
    return Object.entries(baseStyles).reduce((updatedStyles, [styleKey, base]) => {
        const override = overrides[styleKey];
        return {
            ...updatedStyles,
            [styleKey]: override
                ? {
                    ...base,
                    ...override,
                }
                : base,
        };
    }, baseStyles);
};
export const overrideTypographyStyles = (baseStyles, overrides) => {
    return Object.entries(baseStyles).reduce((updatedStyles, [styleKey, base]) => {
        return {
            ...updatedStyles,
            [styleKey]: {
                ...base,
                ...overrides,
            },
        };
    }, baseStyles);
};
//# sourceMappingURL=utils.js.map